module.exports = __webpack_public_path__ + "img/background2.8844e952.jpg";